/**
 *  Created by piotr@revisual.io on 13/08/2025
 */
import classNames from "classnames";
import { ucFirst } from "../../../../helpers/string";

export const SubscriptionIntervalButton = ({
  onIntervalChange,
  isSelected,
  interval,
  label,
}) => {
  return (
    <div
      role="presentation"
      className={classNames(
        "subscription-plan-table-selectors-interval-button",
        {
          "subscription-plan-table-selectors-interval-button_selected":
            isSelected,
        }
      )}
    >
      <button
        id={`1-${interval}-tab`}
        data-testid="1-month-tab-button"
        role="tab"
        type="button"
        aria-controls="1-month-tab-panel"
        aria-label={ucFirst(interval)}
        aria-selected="true"
        tabIndex="0"
        title={ucFirst(interval)}
        onClick={onIntervalChange(interval)}
      >
        <div className="subscription-plan-table-selectors-interval-button-content">
          <div className="Tabs-TabListPaymentMethod">
            <div className="Tabs-TabListPaymentLabel" data-text={label}>
              {label}
            </div>
          </div>
        </div>
      </button>
    </div>
  );
};

export default SubscriptionIntervalButton;
